import React from 'react'
import { QuantityInput } from '../../../components/QuantityInput'
import { useContext } from '../Context'
import { useUpdateToCart } from '../../../hooks/useUpdateToCart'

export const QuantityInputWithUpdate = ({
  quantity,
  itemId,
  uomSymbol,
}: {
  quantity: number
  itemId: string
  uomSymbol?: string
}) => {
  const { document, canEdit } = useContext()
  const orderId = document?._id

  const { updateToCart, loading } = useUpdateToCart()
  const { setShowLoadingOverlay } = useContext()

  const _setOrderQty = async (qty) => {
    if (loading) return

    setShowLoadingOverlay(true)
    try {
      await updateToCart({ itemId, orderId, quantity: qty })
    } finally {
      setShowLoadingOverlay(false)
    }
  }

  return (
    <QuantityInput
      quantity={quantity}
      setQuantity={_setOrderQty}
      isBusy={loading}
      canEdit={canEdit}
      uomSymbol={uomSymbol}
    />
  )
}
